export function filterAllowedValues(prompts) {
  const cleanedArray = prompts?.map((prompt) => {
    return {
      ...prompt,
      allowableValues: (prompt.allowableValues || []).filter(
        (value) => value && value !== ''
      ),
    };
  });

  return cleanedArray || [];
}

export function getNeededPrompts(prompts, punchMessageKey) {
  const inPhrases = ['PunchIn', 'EndBreak', 'EndMeal'];
  const outPhrases = ['PunchOut', 'StartBreak', 'StartMeal'];
  const transferPhrases = ['Transfer'];

  const neededPrompts = prompts?.filter(({ collectWhen }) => {
    if (collectWhen === 'None') {
      return false;
    }
    if (transferPhrases.includes(punchMessageKey)) {
      return true;
    }
    if (inPhrases.includes(punchMessageKey) && collectWhen === 'I') {
      return true;
    }
    if (outPhrases.includes(punchMessageKey) && collectWhen === 'O') {
      return true;
    }
    return false;
  });

  return neededPrompts || [];
}

export function resolveNeededClockPrompts(allPrompts, punch) {
  return filterAllowedValues(getNeededPrompts(allPrompts, punch));
}

export function buildPromptRoutePayload({
  clockPrompts,
  punch,
  punchResult,
  overridePunch,
}) {
  const { expectedPunches } = punchResult || {};

  const payload = {
    clockPrompts,
    expectedPunches: expectedPunches || [punch],
    punch,
  };

  // Explicit param (offline path) wins; otherwise honor the punch result
  // flag (online path) so isPunchStatusOverride is preserved.
  const shouldOverridePunch = overridePunch ?? punchResult?.overridePunch;

  if (shouldOverridePunch) {
    payload.isPunchStatusOverride = '1';
  }

  return payload;
}

export const CLOCK_PROMPTS_ROUTE = '/clock/web/pop-ups/prompts';
